var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name !== 'Raffle')?_c('vue-header'):_vm._e(),_c('router-view',{staticClass:"main"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }